import { Component } from 'react';
import Collapse from 'reactstrap/es/Collapse';
import NavLink from 'reactstrap/es/NavLink';
import NavItem from 'reactstrap/es/NavItem';
import classNames from 'classnames';
import iconChevron from '../../../../../Images/icon/chevron.svg';
import {ReactSVG} from "react-svg";

class SubMenu extends Component {
	state = {
		collapsed: true
	};

	toggleNavbar = () => {
		this.setState({
			collapsed: !this.state.collapsed
		});
	};

	render () {
		const { icon, title, children } = this.props;
		return (
			<div>
				<NavItem onClick={this.toggleNavbar} className={classNames('sidebar_list-item',{ 'menu-open': !this.state.collapsed })}>
					<NavLink className="dropdown-toggle" href="#" >
						{icon || null}
						{title}
						<ReactSVG src={iconChevron} className={'dropdown_icon'}/>
					</NavLink>
				</NavItem>
				<Collapse isOpen={!this.state.collapsed} navbar className={classNames('items-menu', { 'mb-1': !this.state.collapsed })}>
					{children}
				</Collapse>
			</div>
		);
	}
}

export default SubMenu;
